import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    ceremonyNewsDetail: null,
  },
  getters: {},
  mutations: {
    setCeremonyNewsDetail(state, payload) {
      state.ceremonyNewsDetail = payload
    },
  },
  actions: {},
  modules: {},
})
